import React from 'react';
import { userInviteCreate } from '../../../../../../../helpers/user-helper';
import { defaultCreateFormState } from '../helpers/settingsUsersFormConfig';

export const useSettingsUsersCreateForm = ({ token }) => {
    const [isSaving, setIsSaving] = React.useState(false);
    const [error, setError] = React.useState('');
    const [successMessage, setSuccessMessage] = React.useState('');
    const [form, setForm] = React.useState(defaultCreateFormState);

    const handleInputChange = React.useCallback((event) => {
        const { name, value } = event.target;
        setForm((previous) => ({
            ...previous,
            [name]: value,
        }));
    }, []);

    const handleSubmit = React.useCallback(async (event) => {
        event.preventDefault();

        if (!token || isSaving) {
            return;
        }

        const payload = {
            firstName: String(form.firstName || '').trim(),
            lastName: String(form.lastName || '').trim(),
            email: String(form.email || '').trim().toLowerCase(),
            role: String(form.role || 'USER').trim().toUpperCase(),
        };

        payload.name = `${payload.firstName} ${payload.lastName}`.trim();

        if (!payload.firstName || !payload.lastName || !payload.email) {
            setError('Completa nombre, apellido y correo electrónico.');
            setSuccessMessage('');
            return;
        }

        setIsSaving(true);
        setError('');
        setSuccessMessage('');

        const resp = await userInviteCreate(token, payload);

        if (!resp?.success) {
            setError(resp?.message || 'No se pudo crear el usuario.');
            setIsSaving(false);
            return;
        }

        setForm(defaultCreateFormState);
        setSuccessMessage(resp?.message || 'Usuario creado. Se envió el correo de activación.');
        setIsSaving(false);
    }, [token, form, isSaving]);

    return {
        form,
        isSaving,
        error,
        successMessage,
        handleInputChange,
        handleSubmit,
    };
};
